import React, { useState, useEffect } from 'react';
import Layout from '@/components/Layout';
import { Music } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';

import { useToast } from '@/hooks/use-toast';
import PlaylistCard from '@/components/playlists/PlaylistCard';
import { fetchUserPlaylists, SPOTIFY_USER_ID, type Playlist } from '@/services/spotifyService';
const SpotifyPlaylists = () => {
  const [playlists, setPlaylists] = useState<Playlist[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const {
    toast
  } = useToast();
  
  useEffect(() => {
    const load = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const data = await fetchUserPlaylists(SPOTIFY_USER_ID, 50);
        setPlaylists(data);
      } catch (err: any) {
        console.error('Error fetching Spotify playlists:', err);
        setError(err.message);
        toast({
          title: 'Error Loading Playlists',
          description: 'Could not load playlists from Spotify. Please try again later.',
          variant: 'destructive',
        });
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, [toast]);
  return <Layout>
      <div className="article-container py-8">
        <div className="flex items-center mb-6">
          <Music className="text-green-500 mr-2" />
          <h1 className="text-3xl font-chroma font-normal">Everhouse Playlists</h1>
        </div>
        
        <p className="text-muted-foreground mb-6">Soundtracks for your downtime. Curated playlists from E and friends, made to linger alongside the stories you love.</p>
        
        {isLoading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {[...Array(12)].map((_, index) => <Card key={index} className="overflow-hidden border border-gray-200">
                <div className="aspect-square bg-gray-200 animate-pulse" />
                <CardHeader className="pb-2">
                  <div className="h-6 bg-gray-200 rounded animate-pulse w-3/4"></div>
                </CardHeader>
                <CardContent>
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-full mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-5/6 mb-3"></div>
                  <div className="flex justify-between mb-3">
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/4"></div>
                    <div className="h-3 bg-gray-200 rounded animate-pulse w-1/4"></div>
                  </div>
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-1/3"></div>
                </CardContent>
              </Card>)}
          </div> : error ? <div className="text-center py-12">
            <h3 className="text-xl font-semibold mb-2 text-red-500">Something went wrong</h3>
            <p className="text-muted-foreground mb-4">{error}</p>
          </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {playlists.map((playlist, index) => <PlaylistCard key={index} {...playlist} isPreselected={index === 0} />)}
          </div>}
      </div>
    </Layout>;
};
export default SpotifyPlaylists;